import React from 'react';
import './WelcomeSection.css';

const WelcomeSection: React.FC = () => {
  return (
    <section className="Welcome" id="welcome-section">
        <div className='image-section'>
            <img src='../sageti_porumb.png' width={'540'} alt='corn-arrow'/>
        </div>
       <div className='text-section'>
        <h2>Noi suntem Neksio Land!</h2>
        <p>
        Suntem o afacere  cu o tradiție solidă, de peste 30 de ani,  dedicată furnizării de soluții complete pentru clienții noștri. Oferim servicii de transport cereale, ingrasaminte chimice, agregate, paletizat cu prelate , rapid, sigur și eficient, precum și comerț cu cereale, agregate și îngrășăminte chimice, toate la cele mai înalte standarde de calitate.
        <br/>
        Cu o flotă de camioane, alături de depozite bine echipate, suntem pregătiți să răspundem oricăror cerințe.
        <br/>
        Experiența noastră îndelungată ne-a ajutat să construim relații durabile cu clienți din toată țara, cărora le oferim constant profesionalism, eficiență și calitate. La Neksio Land, fiecare colaborare este mai mult decât un simplu serviciu – este un angajament față de succesul partenerilor noștri.
        </p>
      </div> 
    </section>
  );
};

export default WelcomeSection;
